<div class="event-card-container">
  <div class="card-header">Convite Transferência</div>
  <div class="card-content" [class.no-actions]="invitation.status === invitationStatusEnum.PENDING">
    <div class="event-info-area">
      <div class="event-title-area">
        <p>{{ invitation.event_title }}</p>
      </div>
      <div class="event-banner-area">
        <img [src]="loadEventImage(invitation.event.thumbnail)" alt="Banner do evento" />
      </div>
      <div class="event-details-area">
        <p>{{ invitation.event.start_date | date: "short" }} - {{ invitation.event.start_date | date: "shortTime" }}</p>
        <p>{{ invitation.event.address.location_name }}</p>
        <p>{{ invitation.event.address.street }} - {{ invitation.event.address.number }}</p>
        <p>{{ invitation.event.address.city_name }} - {{ invitation.event.address.state }}</p>
      </div>
    </div>
    @if (invitation.status === invitationStatusEnum.PENDING) {
      <div class="actions-area">
        <app-button (btnClick)="handleAcceptClick()" styleType="primary" [disabled]="isLoading">ACEITAR</app-button>
        <app-button (btnClick)="handleDeclineClick()" styleType="secondary" [disabled]="isLoading">RECUSAR</app-button>
      </div>
    } @else if (invitation.status === invitationStatusEnum.ACCEPTED) {
      <div class="actions-area">
        <app-button [routerLink]="['/my-orders']" styleType="primary" class="col-span">
          VISUALIZAR INGRESSOS
        </app-button>
      </div>
    }
    <div class="invite-info-area">
      <div class="sender-info-area invite-info-field">
        <p><b>Remetente: </b></p>
        @if (invitation.sender_name) {
          <p>{{ invitation.sender_name }}</p>
        }
        <p>{{ invitation.sender_email }}</p>
      </div>

      <div class="status-area invite-info-field">
        <p>
          <b>Status: </b>
          <span class=" status status--{{ invitation.status.toLowerCase() }}">{{
            invitation.status | invitationStatusEnum
          }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
